module.exports = __webpack_public_path__ + "static/media/calendar.3a1389a5.svg";